module.exports = __webpack_public_path__ + "static/media/52.c48a91c0.jpg";